import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import Flex from "../../../../components/Flex";
import Text from "../../../../components/Text";
import { AddNewPatientTab, PATIENT_DETAIL } from "./UpsertPatientForm";

interface TopTabPanelProps {
  selectedTab: AddNewPatientTab;
  onClickTab: (tab: AddNewPatientTab) => void;
  title?: string;
  onBackClick?: () => void;
}

const TopTabsPanel = ({
  selectedTab,
  onClickTab,
  title,
  onBackClick,
}: TopTabPanelProps) => {
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      {title && onBackClick && (
        <Button
          variant="text"
          startIcon={<ChevronLeftIcon />}
          onClick={onBackClick}
          sx={{
            textTransform: "none",
            color: "#21262B",
            fontWeight: 500,
            fontSize: 16,
            px: 1,
            mb: 1,
          }}
        >
          {title}
        </Button>
      )}
      <Box
        sx={{
          borderBottom: "0.01px solid #d5ced0",
        }}
      >
        <Tabs value={selectedTab} onChange={(_, tab) => onClickTab(tab)}>
          {PATIENT_DETAIL.map((item, ind) => (
            <Tab
              key={item}
              value={item}
              sx={ACTIVE_COMPONENT_STYLE}
              label={
                <Flex gap={"5px"} alignItems={"center"} mr={"0.6em"}>
                  <Text
                    ml={1}
                    display={"flex"}
                    alignItems={"center"}
                    height={"30px"}
                    // bgcolor={"#1A1A1A0D"}
                    justifyContent={"center"}
                    // borderRadius={"50%"}
                  >
                    {ind + 1}
                  </Text>
                  <Text fontWeight={410} textTransform="none" fontSize={"1rem"}>
                    {item}
                  </Text>
                </Flex>
              }
            />
          ))}
        </Tabs>
      </Box>
      <Flex gap={0.1} mt={1}>
        <Typography
          component={"span"}
          color={"error"}
          sx={{
            fontSize: "13px",
          }}
        >
          {` *`}
        </Typography>
        <Text>Indicates mandatory fields</Text>
      </Flex>
    </Box>
  );
};
export default TopTabsPanel;

const ACTIVE_COMPONENT_STYLE = {
  "&.Mui-selected ": {
    height: "auto",
    opacity: 1,
    bgcolor: "#CCECFF4D",
    animation: 0,
  },
};
